export function getFilename(fullPath: string) {
  return fullPath.replace(/^.*[\\/]/, '');
}
